export const slides = [
  {
    id: "s1",
    title: "星河之下",
    subtitle: "失联百年的殖民舰重返太阳系，一个坐标改写人类命运",
    image: "https://readdy.ai/api/search-image?query=epic%20cinematic%20space%20scene%20with%20a%20giant%20spiral%20galaxy%20and%20a%20lone%20spaceship%20silhouette%2C%20deep%20teal%20nebula%20with%20warm%20orange%20core%20glow%2C%20dramatic%20lighting%2C%20high%20detail%2C%20wide%20composition&width=1920&height=820&seq=hero-slide-01&orientation=landscape",
    type: "movie" as const,
    targetId: "1001",
    badge: "热门影视",
  },
  {
    id: "s2",
    title: "山海归途",
    subtitle: "水墨绘就东方幻想，少年背负山海图踏上千年归途",
    image: "https://readdy.ai/api/search-image?query=oriental%20fantasy%20panorama%20of%20floating%20mountains%20and%20misty%20clouds%20with%20a%20traveler%20on%20a%20bridge%2C%20ink%20painting%20teal%20tones%20with%20warm%20orange%20sunrise%2C%20epic%20atmospheric%20mood%2C%20wide%20composition&width=1920&height=820&seq=hero-slide-02&orientation=landscape",
    type: "movie" as const,
    targetId: "1003",
    badge: "焦点推荐",
  },
  {
    id: "s3",
    title: "剑起长歌",
    subtitle: "一柄锈剑，一介凡人，踏上问鼎巅峰的长歌之路",
    image: "https://readdy.ai/api/search-image?query=wuxia%20panorama%20of%20a%20lone%20swordsman%20on%20a%20cliff%20under%20a%20huge%20moon%2C%20ink%20brush%20mountains%20and%20mist%2C%20teal%20night%20tones%20with%20warm%20orange%20moon%20glow%2C%20dramatic%20martial%20atmosphere%2C%20wide%20composition&width=1920&height=820&seq=hero-slide-03&orientation=landscape",
    type: "novel" as const,
    targetId: "2001",
    badge: "热门小说",
  },
  {
    id: "s4",
    title: "短剧市场百花齐放",
    subtitle: "精品化趋势渐显，题材多样性与制作水准同步提升",
    image: "https://readdy.ai/api/search-image?query=modern%20entertainment%20studio%20with%20screens%20and%20soft%20studio%20lighting%2C%20teal%20and%20warm%20orange%20tones%2C%20editorial%20industry%20mood%2C%20wide%20composition&width=1920&height=820&seq=hero-slide-04&orientation=landscape",
    type: "news" as const,
    targetId: "3009",
    badge: "娱乐资讯",
  },
];